import React, { Component } from 'react'
import { withRouter } from 'react-router-dom'
import CacheKeys from '../../../cache/CacheKeys'
import CacheManager from '../../../cache/CacheManager'
import RestApiUtils from '../../../apiclient/moebli/RestApiUtils'
import UseOfProceedsDraftPageUI from './UseOfProceedsDraftPageUI.js'

class UseOfProceedsDraftPageSF extends Component {
  constructor(props) {
    super(props)
    this.state = {
      errorList: null,
      loan: null,
      //
      createMode: false,
      downloadDraftProceedsTemplateRequested: false,
      bulkUploadMode: false,
    }
  }

  render() {
    return (
      <UseOfProceedsDraftPageUI
        context={this.props.context}
        errorList={this.state.errorList}
        loan={this.state.loan}
        onRefreshClick={this.onRefreshClick}
        //
        createMode={this.state.createMode}
        onCreateClick={() => { this.setState({ createMode: true }) }}
        onCreateCancel={() => { this.setState({ createMode: false }) }}
        //
        downloadDraftProceedsTemplateRequested={this.state.downloadDraftProceedsTemplateRequested}
        onDownloadDraftProceedsTemplate={this.onDownloadDraftProceedsTemplate}
        //
        bulkUploadMode={this.state.bulkUploadMode}
        onBulkUploadClick={() => { this.setState({ bulkUploadMode: true }) }}
        onBulkUploadCancel={() => { this.setState({ bulkUploadMode: false }) }}
      />
    )
  }

  componentDidMount() {
    let context = this.props.context
    this.getLoan(context)
  }

  getLoan(context) {
    let cacheManager = new CacheManager({
      resource: `/api/su/loans/${this.props.match.params.loanId}`,
      cacheKey: CacheKeys.Loan(this.props.match.params.loanId),
      callback: this.getLoanCallback,
      ttlInSecs: 600
    })
    cacheManager.getObject2(context)
  }

  getLoanCallback = (response) => {
    let context = this.props.context
    this.setState({ errorList: response.errorList, loan: response.loan })
  }

  onRefreshClick = () => {
    let loan = this.state.loan
    let context = this.props.context
    CacheManager.removeObject(CacheKeys.Loan(loan.loanId))
    this.setState({
      loan: null,
      errorList: null,
    })
    this.getLoan(context)
  }

  onDownloadDraftProceedsTemplate = () => {
    let context = this.props.context
    this.setState({ downloadDraftProceedsTemplateRequested: true })
    RestApiUtils.get(context, `/api/pub/contents/loan_file_upload_templates/draft_use_of_proceeds.xlsx`,
      this.onDownloadDraftProceedsTemplateCallback, null, null)
  }

  onDownloadDraftProceedsTemplateCallback = (response) => {
    this.setState({ downloadDraftProceedsTemplateRequested: false })

    if (response.errorList.length === 0) {
      const link = document.createElement('a')
      link.href = response.publicURL
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
    }
  }
}

export default withRouter(UseOfProceedsDraftPageSF)
